import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { ViewsResolver } from './resolvers/views.resolver';
import { InsightsResolver } from './resolvers/insights.resolver';
import { UserDashboardsResolver } from './resolvers/user-dashboards.resolver';
import { SurveyFiltersResolver } from './resolvers/survey-filters.resolver';
import { EmployeeCampaignsResolver } from './resolvers/employee-campaigns-resolver';
import { SelfDashboardsFiltersResolver } from './resolvers/self-dashboards-filters-resolver';
import { SelfDashboardFiltersResolver } from './resolvers/self-dashboard-filters.resolver';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    resolve: {
      views: ViewsResolver,
      insights: InsightsResolver,
      userDashboards: UserDashboardsResolver,
      surveyFilters: SurveyFiltersResolver,
      employeeCampaigns: EmployeeCampaignsResolver,
      selfDashboardsFilters: SelfDashboardsFiltersResolver
    },
    children: [
      // {
      //   path: 'home',
      //   loadChildren: (): any=> import('./x-home/dashboard.module').then((m: any): any => m.DashboardModule)
      // },
      {
        path: 'home',
        loadChildren: (): any=> import('./screens/home/home.module')
          .then((m: any): any => m.HomeModule)
      },
      {
        path: 'welcome',
        loadChildren: (): any=> import('./screens/business-edition/be-welcome.module')
          .then((m: any): any => m.BusinessEditionWelcomeModule)
      },
      {
        path: 'be-settings',
        loadChildren: (): any=> import('./screens/business-edition-settings/be-settings.module')
          .then((m: any): any => m.BusinessEditionSettingsModule)
      },
      {
        path: 'admin',
        loadChildren: (): any=> import('./screens/admin/admin.module')
          .then((m: any): any => m.AdminModule)
      },
      {
        path: 'toolkit',
        loadChildren: (): any=> import('./screens/toolkit/toolkit.module')
          .then((m: any): any => m.ToolkitModule)
      },
      {
        path: 'reports',
        loadChildren: (): any=> import('./screens/reports/reports.module')
          .then((m: any): any => m.ReportsModule)
      },
      {
        path: 'insights',
        loadChildren: (): any=> import('./screens/insights/insights.module')
          .then((m: any): any => m.InsightsModule)
      },
      {
        path: 'saved-user-filters/survey-insights',
        loadChildren: (): any=> import('./screens/survey-filters/survey-filters.module')
          .then((m: any): any => m.SurveyFiltersModule)
      },
      {
        path: 'views',
        loadChildren: (): any=> import('./screens/views/views.module')
          .then((m: any): any => m.ViewsModule)
      },
      {
        // used when dashboards are shared with insight users
        path: 'dashboards',
        loadChildren: (): any=> import('./screens/views/dashboard/dashboard.module')
          .then((m: any): any => m.DashboardModule)
      },
      {
        // used for filtered dashboards
        path: 'saved-user-filters/dashboards',
        loadChildren: (): any=> import('./screens/views/dashboard/dashboard.module')
          .then((m: any): any => m.DashboardModule)
      },
      {
        path: 'views/:viewId/surveys',
        loadChildren: (): any=> import('./screens/survey-dashboard/survey-dashboard.module')
          .then((m: any): any => m.SurveyDashboardModule)
      },
      {
        path: 'views/:viewId/survey-analysis',
        loadChildren: (): any=> import('./screens/survey-analysis/survey-analysis.module')
          .then((m: any): any => m.SurveyAnalysisModule)
      },
      {
        path: 'views/:viewId/flagged-comments',
        loadChildren: (): any=> import('./screens/flagged-comments/flagged-comments.module')
          .then((m: any): any => m.FlaggedCommentsModule)
      },
      {
        path: 'views/:viewId/sentiment-analysis-2',
        loadChildren: (): any => import('./screens/sentiment-analysis/sentiment-analysis.module')
          .then((m: any): any => m.SentimentAnalysisModule)
      },
      {
        // Survale AI: the AI assistant ("Ask your data"); searches across all views
        path: 'survale-ai',
        loadChildren: (): any => import('./screens/sentiment-analysis-3/sentiment-analysis-3.module')
          .then((m: any): any => m.SentimentAnalysis3Module)
      },
      {
        // earlier per-view link
        path: 'views/:viewId/sentiment-analysis-3',
        redirectTo: '/survale-ai'
      },
      {
        path: 'views/:viewId/sentiment-analysis',
        loadChildren: (): any => import('./screens/sentiment-analysis/sentiment-analysis.module')
          .then((m: any): any => m.SentimentAnalysisModule)
      },
      {
        path: 'views/:viewId/sa',
        loadChildren: (): any=> import('./screens/survey-analysis/survey-analysis.module')
          .then((m: any): any => m.SurveyAnalysisModule)
      },
      // { dupe
      //   path: 'views/:viewId/survey-analysis',
      //   loadChildren: (): any=> import('./screens/survey-dashboard/survey-dashboard.module')
      //     .then((m: any): any => m.SurveyDashboardModule)
      // },
      {
        path: 'employee-campaign-results',
        loadChildren: (): any=> import('./screens/employee-campaign-results/employee-campaign-results.module')
          .then((m: any): any => m.EmployeeCampaignResultsModule)
      },
      {
        path: 'cande-fake-menu-1',
        loadChildren: (): any=> import('./screens/survale-enterprise-cande/survale-enterprise-cande.module')
          .then((m: any): any => m.SurvaleEnterpriseCandeModule)
      },
      {
        path: 'cande-fake-menu-2',
        loadChildren: (): any=> import('./screens/survale-enterprise-cande/survale-enterprise-cande.module')
          .then((m: any): any => m.SurvaleEnterpriseCandeModule)
      },
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'no-access',
        loadChildren: (): any=> import('./screens/no-access/no-access.module')
          .then((m: any): any => m.NoAccessModule)
      },
      {
        path: 'landing',
        loadChildren: (): any=> import('./screens/landing/landing.module')
          .then((m: any): any => m.LandingModule)
      },
      {
        path: 'authentication',
        loadChildren: (): any=> import('./screens/session/session.module')
          .then((m: any): any => m.SessionModule)
      },
      {
        path: 'error',
        loadChildren: (): any=> import('./error/error.module')
          .then((m: any): any => m.ErrorModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'session/404'
  }
];
